module.exports = __webpack_public_path__ + "824d0d0e9317e379e4839b061d356498.jpg";